<template>
  <div v-if="pager.pages && pager.pages.length > 1" class="w-full h-7">
    <div class="flex float-left h-full items-center">
      <span class="inline-block text-gray-400 text-xs">
        Showing {{ pager.startIndex + 1 }}-{{ pager.endIndex + 1 }} of
        {{ items.length }}
      </span>
    </div>
    <ul :style="ulStyles" class="pagination float-right text-xs">
      <li
        :style="liStyles"
        :class="{ disabled: pager.currentPage === 1 }"
        class="page-item first"
      >
        <a :style="aStyles" class="page-link" @click="setPage(1)">{{
          labels.first
        }}</a>
      </li>
      <li
        :style="liStyles"
        :class="{ disabled: pager.currentPage === 1 }"
        class="page-item previous"
      >
        <a
          :style="aStyles"
          class="page-link"
          @click="setPage(pager.currentPage - 1)"
        >
          {{ labels.previous }}
        </a>
      </li>
      <li
        v-for="page in pager.pages"
        :key="page"
        :style="liStyles"
        :class="{ active: pager.currentPage === page }"
        class="page-item page-number"
      >
        <a :style="aStyles" class="page-link" @click="setPage(page)">{{
          page
        }}</a>
      </li>
      <li
        :style="liStyles"
        :class="{ disabled: pager.currentPage === pager.totalPages }"
        class="page-item next"
      >
        <a
          :style="aStyles"
          class="page-link"
          @click="setPage(pager.currentPage + 1)"
        >
          {{ labels.next }}
        </a>
      </li>
      <li
        :class="{ disabled: pager.currentPage === pager.totalPages }"
        :style="liStyles"
        class="page-item last"
      >
        <a
          :style="aStyles"
          class="page-link"
          @click="setPage(pager.totalPages)"
        >
          {{ labels.last }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import paginate from 'jw-paginate';

  const defaultLabels = {
    first: 'First',
    last: 'Last',
    previous: 'Previous',
    next: 'Next',
  };

  const defaultStyles = {
    ul: {
      margin: 0,
      padding: 0,
      display: 'inline-block',
    },
    li: {
      listStyle: 'none',
      display: 'inline',
      textAlign: 'center',
    },
    a: {
      cursor: 'pointer',
      padding: '6px 12px',
      display: 'block',
      float: 'left',
    },
  };

  export default {
    props: {
      items: {
        type: Array,
        required: true,
      },
      initialPage: {
        type: Number,
        default: 1,
      },
      pageSize: {
        type: Number,
        default: 10,
      },
      maxPages: {
        type: Number,
        default: 10,
      },
      labels: {
        type: Object,
        default: () => defaultLabels,
      },
      styles: {
        type: Object,
        default: () => {},
      },
      disableDefaultStyles: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        pager: {},
        ulStyles: {},
        liStyles: {},
        aStyles: {},
      };
    },
    watch: {
      items() {
        this.setPage(this.initialPage);
      },
    },
    created() {
      this.$router.replace({ name: this.$route.name, query: { page: 1 } });
      if (!this.$listeners.changePage) {
        throw 'Missing required event listener: "changePage"';
      }

      // set default styles unless disabled
      if (!this.disableDefaultStyles) {
        this.ulStyles = defaultStyles.ul;
        this.liStyles = defaultStyles.li;
        this.aStyles = defaultStyles.a;
      }

      // merge custom styles with default styles
      if (this.styles) {
        this.ulStyles = { ...this.ulStyles, ...this.styles.ul };
        this.liStyles = { ...this.liStyles, ...this.styles.li };
        this.aStyles = { ...this.aStyles, ...this.styles.a };
      }

      // set to initial page
      this.setPage(this.initialPage);
    },
    methods: {
      setPage(page) {
        const { items, pageSize, maxPages } = this;

        // get new pager object for specified page
        const pager = paginate(items.length, page, pageSize, maxPages);

        // get new page of items from items array
        const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update pager
        this.pager = pager;
        this.$router.replace({ name: this.$route.name, query: { page: page } });
        // emit change page event to parent component
        this.$emit('changePage', pageOfItems);
      },
    },
  };
</script>

<style lang="scss">
  ul {
    &.pagination {
      li {
        color: #a1a1aa;
        font-weight: 600;
        &.page-number {
          a {
            border-radius: 5px;
          }
          &:hover {
            a {
              background-color: #eff2f5;
            }
          }
          &.active {
            a {
              background-color: #7f89a1;
              color: #fff;
            }
            &:hover {
              a {
                background-color: #7f89a1;
              }
            }
          }
        }
        &.disabled a {
          opacity: 0.5;
          cursor: default !important;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// JwPagination.vue?dc8e6616